/* eslint-disable react/prop-types */ // TODO: add props
import { OverlayTrigger, Popover } from 'react-bootstrap';
import _ from 'lodash';

/** Components */
import ShareLink from 'edrolo/components/common/ShareLink';

const LessonTitle = ({ classId, lessonId, title, keyKnowledgeText }) => {
  const popoverText =
    keyKnowledgeText || 'There is no key knowledge listed for this lesson';
  const shareLink = (
    <ShareLink
      title="To share this lesson with students, copy and paste this link:"
      model="lesson"
      objectId={lessonId}
      classId={classId}
      shareType="lesson"
      utm_campaign="topicgrid"
      origin="topic_grid"
    >
      <button className="share-link">
        <i className="icon-share-square-o" />
      </button>
    </ShareLink>
  );

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="right"
      overlay={<Popover id={_.uniqueId()}>{popoverText}</Popover>}
    >
      <span>
        {title}
        {shareLink}
      </span>
    </OverlayTrigger>
  );
};

export default LessonTitle;
